import script from "./ClientHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientHome.vue?vue&type=script&setup=true&lang=ts"

import "./ClientHome.vue?vue&type=style&index=0&id=86f3023a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86f3023a"]])

export default __exports__